export function ErrorMessage({ error }: { error: string }) {
	return <>{error && <div className="text-sm text-red-500">{error}</div>}</>
}
